import { useMatch } from 'react-router';

import { ROUTES } from '@/shared/config/routes';

export type ReelsRouteKind = 'home' | 'brands' | 'settings' | 'wizard';

/** The new-reel and saved-reel wizard routes share one kind, so the new to saved redirect is not a page change. */
export const useReelsRouteKind = (): ReelsRouteKind => {
  const isHome = useMatch({ path: ROUTES.REELS_CREATOR, end: true }) !== null;
  const isBrands = useMatch({ path: ROUTES.REELS_CREATOR_BRANDS, end: true }) !== null;
  const isSettings = useMatch({ path: ROUTES.REELS_CREATOR_SETTINGS, end: true }) !== null;
  // The harness's old address only redirects into the brand kit, so it wears the brand kit's frame.
  const isHarness = useMatch({ path: ROUTES.REELS_CREATOR_HARNESS, end: true }) !== null;

  if (isHome) return 'home';
  if (isSettings) return 'settings';
  return isBrands || isHarness ? 'brands' : 'wizard';
};
